import styled from 'styled-components';

export const StyledRow = styled.div`
  display: flex;
  flex-wrap:wrap;
  clear: both; 
`;

export const StyledColumn = styled.div`
  max-width:100%;
`;
